import React from "react";
import cs from "classnames";
import PropTypes from "prop-types";

import { ErrorBoundary } from "@lululemon/mwa-logger";

import IconByName from "../icon-by-name/icon-by-name";
// import ProductBadging from "../product-badging/product-badging";
import { productEdHandleError } from "../../utils/product-education-logger";

import styles from "./why-you-love-this-material-and-care.module.scss";

const getMaterialElement = (materialAttributes) => {
  if (materialAttributes) {
    return materialAttributes.map((attribute) => {
      const { list } = attribute;

      if (list) {
        return (
          <dl className="lll-text-body-3" key={list?.title}>
            <dt className={styles.dt}>{`${list?.title}: `}</dt>
            {list?.items?.map((listItem, index) => {
              const separator = index + 1 !== list?.items?.length ? ", " : "";
              return (
                <dd
                  className={styles.dd}
                  key={listItem}
                >{`${listItem}${separator}`}</dd>
              );
            })}
          </dl>
        );
      }
    });
  }

  return null;
};

const getCareElement = (careAttributes) => {
  if (careAttributes) {
    return (
      <ul className={cs("lll-text-body-3", styles.careIcons)}>
        {careAttributes.map((attribute) => {
          const { text, iconId } = attribute;

          if (text) {
            return (
              <li className={styles.item} key={text}>
                {iconId && (
                  <IconByName alt="" name={iconId} className={styles.icon} />
                )}
                <span>{text}</span>
              </li>
            );
          }
        })}
      </ul>
    );
  }

  return null;
};

function WhyYouLoveThisMaterialAndCare({
  doubleLinedText,
  materialAndCare,
  title
}) {
  const sections = materialAndCare?.sections;

  const materialSection = sections?.find((s) => s?.title === "Materials");
  const careSection = sections?.find((s) => s?.title === "Care");

  const materialElement = getMaterialElement(materialSection?.attributes);
  const careElement = getCareElement(careSection?.attributes);

  const hasContent = !!materialElement || !!careElement || !!doubleLinedText;

  if (hasContent) {
    return (
      <ErrorBoundary
        onError={(error) =>
          productEdHandleError(error, "WYLT Material and Care", "WYLT")
        }
      >
        <div className="OneLinkTx">
          {title && (materialElement || careElement) && (
            <h4 className={styles.title}>{title}</h4>
          )}
          {materialSection && materialElement}
          {careSection && careElement}
          {doubleLinedText && (
            <p className={cs("lll-text-body-2", styles.linerText)}>
              {doubleLinedText}
            </p>
          )}
        </div>
        {/* <ProductBadging /> */}
      </ErrorBoundary>
    );
  }

  return null;
}

WhyYouLoveThisMaterialAndCare.propTypes = {
  doubleLinedText: PropTypes.string,
  materialAndCare: PropTypes.shape({
    sections: PropTypes.array
  }),
  title: PropTypes.string
};

WhyYouLoveThisMaterialAndCare.defaultProps = {
  doubleLinedText: "",
  materialAndCare: {},
  title: "Materials and Care"
};

export default WhyYouLoveThisMaterialAndCare;
